var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useContext } from "react";
import FilteredOverviewPage from "../FilteredOverviewPage";
import { getRoute } from "../../routes/getAllRoutes";
import styles from "./CohortSkillGroupV2.module.scss";
import { FilterContext } from "../../providers/FilterProvider";
import { CohortFilterSet } from "../Filters/Filters";
import { getClientId, useGetCohortReportLeaderCount, useGetLeaderScoreAggByAssessmentQuery, useGetLookupsFiltersQuery, useGetSingleAvailableCohortReportsQuery, useGetProjectFunctions, } from "../../store/api/core";
import LevelFunctionMatrix from "../LevelFunctionMatrix";
import { getCohortCell } from "../LevelFunctionMatrix/Variants";
import { useHeatmap, useDynamicHeatmapScores } from "../../hooks/heatmapScores";
import { useConfidentialReportView } from "../../hooks/confidentialReportView";
import { DownloadableSection } from "../DownloadableSection/DownloadableSection";
import { useParams } from "react-router-dom";
import PageNotFound from "../PageNotFound";
import { DistributionBarSet } from "../DistributionBarSet/DistributionBarSet";
import { cohortSet } from "../../common/cohortConfiguration";
import LeaderCount from "../LeaderCount";
import { MutateReportButtons } from "../Cohort/cohort";
import { Breadcrumb } from "../Breadcrumb/Breadcrumb";
import { ProjectNameText } from "../../common/cohortTableColumns";
export var LegendImages = function (_a) {
    var images = _a.images;
    return (_jsx("div", __assign({ className: styles.legendImages }, { children: images === null || images === void 0 ? void 0 : images.map(function (image) { return (_jsx("div", __assign({ className: styles.legendImageItem }, { children: image.src ? (_jsx("img", { src: image.src, alt: image.alt, className: image.className, title: image.title })) : (image.image) }), image.key)); }) })));
};
var handleIdData = function (projectFilters) {
    return function (current, next) {
        if (Array.isArray(next)) {
            return next.reduce(handleIdData(projectFilters), current);
        }
        else if (typeof next === "object" && next != null) {
            if ((projectFilters.size == 0 || projectFilters.has(next["project_id"])) &&
                next["project_id"] &&
                next["project_id"] != "ALL") {
                current.projects.add(next["project_id"]);
            }
            if (next["function_id"] && next["function_id"] != "ALL") {
                current.functions.add(next["function_id"]);
            }
            var newCurrent = current;
            for (var _i = 0, _a = Object.values(next); _i < _a.length; _i++) {
                var value = _a[_i];
                newCurrent = handleIdData(projectFilters)(newCurrent, value);
            }
            return newCurrent;
        }
        return current;
    };
};
var ProjectName = function (_a) {
    var id = _a.id;
    return (_jsx("span", __assign({ className: styles.projectName }, { children: _jsx(ProjectNameText, { id: id }) })));
};
export var useOverviewInformation = function (skillGroup, category, reportId) { return function () {
    var _a, _b, _c;
    var getFilters = useContext(FilterContext).getFilters;
    var projects = useGetProjectFunctions({
        filters: getFilters(),
        reportId: reportId,
        skillGroup: skillGroup,
        category: category,
    });
    var lookups = useGetLookupsFiltersQuery({
        clientId: getClientId(),
    });
    var axisIds = ((_a = projects.data) === null || _a === void 0 ? void 0 : _a.data.functions.reduce(handleIdData(new Set(((_b = getFilters()) === null || _b === void 0 ? void 0 : _b.project) || [])), {
        projects: new Set(),
        functions: new Set(),
    })) || {
        projects: new Set(),
        functions: new Set(),
    };
    var returnable = {
        data: {
            indexForLevelId: Array.from(axisIds.functions).reduce(function (current, next, index) {
                var _a;
                return (__assign(__assign({}, current), (_a = {}, _a[next] = index + 1, _a)));
            }, {}),
            primaryFunctions: Array.from(axisIds.projects),
            lookupCodeMap: Array.from(axisIds.projects).reduce(function (current, id) {
                var _a;
                return (__assign(__assign({}, current), (_a = {}, _a[id] = _jsx(ProjectName, { id: id }), _a)));
            }, (_c = lookups === null || lookups === void 0 ? void 0 : lookups.data) === null || _c === void 0 ? void 0 : _c.data.lookupCodeMap),
            functionIndexes: Array.from(axisIds.projects).reduce(function (current, id, index) {
                var _a;
                return (__assign(__assign({}, current), (_a = {},
                    _a[id] = {
                        functionIndex: index + 1,
                        functionName: id,
                        subFunctions: {},
                    },
                    _a)));
            }, {
                ALL: {
                    functionIndex: 0,
                    functionName: "All Projects",
                    subFunctions: {},
                },
            }),
        },
    };
    return returnable;
}; };
var useProjectFunctionHeatmap = function (skillGroup, category, reportId) {
    return function (_a) {
        var riskRole = _a.riskRole;
        return useHeatmap(useOverviewInformation(skillGroup, category, reportId), useGetProjectFunctions, function (data) { return ({ data: data }); }, function () { return ({ state: "nodata" }); }, "", riskRole, { x: "All Projects", y: "All Functions" }, { skillGroup: skillGroup, category: category, reportId: reportId });
    };
};
var LoadedHeatmap = function (_a) {
    var heatmapNavigationKey = _a.heatmapNavigationKey, skillGroup = _a.skillGroup, category = _a.category, reportId = _a.reportId, colors = _a.colors, heatmapDimensions = _a.heatmapDimensions, heatmapLabels = _a.heatmapLabels, heatmapLegendImages = _a.heatmapLegendImages, heatmapTitle = _a.heatmapTitle, showHeatmapScorePercentage = _a.showHeatmapScorePercentage;
    var useHeatmapScores = (heatmapDimensions === null || heatmapDimensions === void 0 ? void 0 : heatmapDimensions.xAxis) && (heatmapDimensions === null || heatmapDimensions === void 0 ? void 0 : heatmapDimensions.yAxis)
        ? useDynamicHeatmapScores({
            reportId: reportId !== null && reportId !== void 0 ? reportId : "",
            skillGroup: skillGroup,
            category: category,
            heatmapDimensions: heatmapDimensions,
            heatmapLabels: heatmapLabels,
            fillEmpty: function () { return ({ state: "nodata" }); },
            projectNameRenderer: function (id) { return _jsx(ProjectName, { id: id }); },
        })
        : useProjectFunctionHeatmap(skillGroup, category, reportId);
    return (_jsx("div", __assign({ className: styles.innerHeatmapContainer }, { children: _jsxs(DownloadableSection, __assign({ filename: "heatmap.png" }, { children: [heatmapTitle, _jsx(LevelFunctionMatrix, { useHeatmapScores: useHeatmapScores, getExpandedCell: function () { return null; }, getDataCell: getCohortCell(colors.colors, colors.chooser, heatmapLegendImages, showHeatmapScorePercentage)(heatmapNavigationKey), unexpandable: true })] })) })));
};
export var CohortSkillGroupParamatizerV2 = function () {
    var _a, _b;
    var _c = useParams(), reportId = _c.reportId, skillGroup = _c.skillGroup;
    var reportData = useGetSingleAvailableCohortReportsQuery({
        reportId: reportId || "",
    });
    var _d = reportData.data || {}, assessmentCategory = _d.assessmentCategory, reportName = _d.reportName, isConfidential = _d.isConfidential, heatmapDimensions = _d.heatmapDimensions, heatmapLabels = _d.heatmapLabels;
    // Confidential view = report is confidential AND the admin has not switched to
    // the Heidrick Validation Version. Drives leader masking in the drilldown.
    var isConfidentialView = useConfidentialReportView(isConfidential).isConfidentialView;
    var set = (_a = cohortSet === null || cohortSet === void 0 ? void 0 : cohortSet[assessmentCategory || ""]) === null || _a === void 0 ? void 0 : _a[skillGroup || ""];
    if (!set) {
        return (_jsx(PageNotFound, { title: "Page Not Found", description: "Url Skill Group and/or Category not found" }));
    }
    var skillGroupInfo = (_b = cohortSet[assessmentCategory || ""]) === null || _b === void 0 ? void 0 : _b[skillGroup || ""];
    var bottomComponent = skillGroupInfo &&
        skillGroupInfo.drilldownBottomComponent &&
        isConfidential != null &&
        skillGroupInfo.drilldownBottomComponent(isConfidentialView);
    return (_jsx(CohortSkillGroup, { title: reportName || "", reportId: reportId || "", isConfidential: isConfidential, assessmentCategory: assessmentCategory || "", reportName: reportName || "", dataKey: skillGroup, category: assessmentCategory, heatmapNavigationKey: getRoute("CohortLeadersRestricted")
            .replace(":reportId", encodeURIComponent(reportId || ""))
            .replace(":skillGroup", encodeURIComponent(skillGroup || "")), cohortSet: set, heatmapDimensions: heatmapDimensions, heatmapLabels: heatmapLabels, bottomComponent: bottomComponent }));
};
export var CohortSkillGroup = function (props) {
    var _a, _b, _c, _d;
    var skillGroupInfo = (_a = cohortSet[props.assessmentCategory || ""]) === null || _a === void 0 ? void 0 : _a[props.dataKey];
    var filters = useContext(FilterContext).getFilters;
    var disableFilters = useConfidentialReportView(props.isConfidential).disableFilters;
    var leaderCountData = useGetCohortReportLeaderCount({
        category: props.assessmentCategory || "",
        filters: filters(),
    }).data;
    return (_jsxs("div", { children: [_jsx(FilteredOverviewPage, { availableFilters: CohortFilterSet, title: (skillGroupInfo === null || skillGroupInfo === void 0 ? void 0 : skillGroupInfo.skillGroupDisplayName) || "", secondaryHeadingTitle: (_c = (_b = cohortSet[props.category]) === null || _b === void 0 ? void 0 : _b[props.dataKey]) === null || _c === void 0 ? void 0 : _c.backTitle, disableFilters: disableFilters, leftTrailer: _jsx("div", __assign({ style: { paddingTop: "2px" } }, { children: _jsx(LeaderCount, { leadersCount: ((_d = leaderCountData === null || leaderCountData === void 0 ? void 0 : leaderCountData.data) === null || _d === void 0 ? void 0 : _d.leadersCount) || 0, countText: "leader" }) })), rightTrailer: _jsx(MutateReportButtons, { reportId: props.reportId || "" }), backToButton: _jsx(Breadcrumb, {}) }), _jsxs("div", __assign({ "data-testid": "CohortLeadershipCapabilities", className: styles.container }, { children: [_jsx(DistributionBarSet, { useChartData: useGetLeaderScoreAggByAssessmentQuery, reportId: props.reportId, category: props.assessmentCategory, skillGroup: (skillGroupInfo === null || skillGroupInfo === void 0 ? void 0 : skillGroupInfo.distributionSkillGroup) || props.dataKey, skillName: skillGroupInfo === null || skillGroupInfo === void 0 ? void 0 : skillGroupInfo.distributionSkillName, title: props.title, barTitle: skillGroupInfo === null || skillGroupInfo === void 0 ? void 0 : skillGroupInfo.barChartTitle((skillGroupInfo === null || skillGroupInfo === void 0 ? void 0 : skillGroupInfo.skillGroupDisplayName) || ""), donutTitle: (skillGroupInfo === null || skillGroupInfo === void 0 ? void 0 : skillGroupInfo.skillGroupDonutTitle) || "" }), _jsx("div", __assign({ className: styles.heatmapContainer }, { children: _jsx("div", __assign({ className: styles.heatmap }, { children: (function () {
                                var _a, _b;
                                return (_jsx(LoadedHeatmap, { heatmapNavigationKey: props.heatmapNavigationKey, skillGroup: props.dataKey, category: props.assessmentCategory, reportId: props.reportId, colors: props.cohortSet.heatmapColors, title: ((_a = props.heatmapLabels) === null || _a === void 0 ? void 0 : _a.xAxis) && ((_b = props.heatmapLabels) === null || _b === void 0 ? void 0 : _b.yAxis)
                                        ? "Average scores by ".concat(props.heatmapLabels.xAxis.toLowerCase(), " and ").concat(props.heatmapLabels.yAxis.toLowerCase())
                                        : (skillGroupInfo === null || skillGroupInfo === void 0 ? void 0 : skillGroupInfo.heatmapTitle) || "", heatmapDimensions: props.heatmapDimensions, heatmapLabels: props.heatmapLabels, heatmapLegendImages: props.cohortSet.heatmapLegendImages, heatmapTitle: props.cohortSet.heatmapTitle, showHeatmapScorePercentage: props.cohortSet.showHeatmapScorePercentage }));
                            })() })) })), props.bottomComponent && (_jsx("div", __assign({ className: styles.scoringFactorContainer }, { children: props.bottomComponent })))] }))] }));
};
